<template>
  <Transition
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
    @after-leave="afterLeave"
    :css="false"
  >
    <slot/>
  </Transition>
</template>

<script setup>
  import gsap from 'gsap';

  function saveStyle(el) {
    if (!el.collapseDataset) {
      el.collapseDataset = {};
    }

    el.collapseDataset.oldOverflow = el.style.overflow;
    el.collapseDataset.oldPaddingTop = el.style.paddingTop;
    el.collapseDataset.oldPaddingBottom = el.style.paddingBottom;
    el.style.overflow = 'hidden';
  }

  function beforeEnter(el) {
    saveStyle(el);
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
  }

  function enter(el, done) {
    gsap.fromTo(el, { height: 0, paddingTop: 0, paddingBottom: 0 }, {
      duration: 0.15,
      height: `${el.scrollHeight}px`,
      paddingTop: el.style.paddingTop,
      paddingBottom: el.style.paddingBottom,
      onComplete() {
        done();
      },
    });
  }

  function afterEnter(el) {
    el.style.height = '';
    el.style.overflow = el.collapseDataset.oldOverflow;
    el.style.paddingTop = el.collapseDataset.oldPaddingTop;
    el.style.paddingBottom = el.collapseDataset.oldPaddingBottom;
  }

  function beforeLeave(el) {
    saveStyle(el);
  }

  function leave(el, done) {
    gsap.to(el, {
      duration: 0.15,
      height: 0,
      paddingTop: 0,
      paddingBottom: 0,
      onComplete() {
        done();
      },
    });
  }

  function afterLeave(el) {
    el.style.height = '';
    el.style.overflow = el.collapseDataset.oldOverflow;
    el.style.paddingTop = el.collapseDataset.oldPaddingTop;
    el.style.paddingBottom = el.collapseDataset.oldPaddingBottom;
  }
</script>
